<template>
  <div
    v-if="isVisible"
    class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity"
  >
    <div class="bg-white rounded-lg p-6 shadow-lg flex flex-col items-center space-y-4 max-w-sm mx-4">
      <div class="spinner w-8 h-8"></div>
      <p class="text-gray-700 text-center">{{ message }}</p>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  isVisible?: boolean
  message?: string
}

withDefaults(defineProps<Props>(), {
  isVisible: false,
  message: '로딩 중...'
})
</script>